"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Typography_1 = require("@material-ui/core/Typography");
var Divider_1 = require("@material-ui/core/Divider");
var react_number_format_1 = require("react-number-format");
var Badge = function (props) {
    var _a, _b;
    var badgeWidth = 30;
    if (((_a = props.text) === null || _a === void 0 ? void 0 : _a.toString().length) !== undefined) {
        badgeWidth += ((((_b = props.text) === null || _b === void 0 ? void 0 : _b.toString().length) - 1) * 14);
    }
    return (React.createElement("div", { style: { display: "inline-flex", justifyContent: "center", alignItems: "center", minWidth: "20px", width: badgeWidth + "px", height: "30px", borderRadius: "100px", color: "white", backgroundColor: "#28a745", fontSize: "1.3rem", fontWeight: 500 } },
        React.createElement(react_number_format_1.default, { value: props.text, thousandSeparator: true, displayType: 'text' })));
};
function PageHeading(props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(Typography_1.default, { variant: "h3", gutterBottom: true, style: { paddingTop: "1rem", display: "inline-flex", alignItems: "center" } },
            props.titleIcon && React.createElement(props.titleIcon, { style: { transform: "scale(1.9)" } }),
            React.createElement("span", { style: { paddingLeft: props.titleIcon ? "15px" : "0px" } }, props.title)),
        React.createElement(Divider_1.default, null),
        React.createElement(Typography_1.default, { style: { paddingTop: "0.35em", paddingBottom: props.noBottomPadding ? "none" : "3rem" }, color: "textSecondary", variant: "h5" },
            props.badgeText && React.createElement(Badge, { text: props.badgeText }),
            " ",
            props.subtitle)));
}
exports.default = PageHeading;
//# sourceMappingURL=PageHeading.js.map